import { ProductType } from '@common/enums';
import { ProductQty, SelectedItemMap } from '@common/models';
import { convertProductsToProductDetailsList } from '@common/utils';
import { productQtyFromSelectedItems } from '@common/utils/productQtyFromSelectedItems';

export const convertTearOutsToProductDetails = convertProductsToProductDetailsList(ProductType.TEAR_OUT);

export const getTearOutsProductQty = (selectedTearOuts: SelectedItemMap): ProductQty[] =>
    productQtyFromSelectedItems(selectedTearOuts);
